import { render, staticRenderFns } from "./order_edit.vue?vue&type=template&id=1a27b6fe&scoped=true&"
import script from "./order_edit.vue?vue&type=script&lang=js&"
export * from "./order_edit.vue?vue&type=script&lang=js&"
import style0 from "./order_edit.vue?vue&type=style&index=0&id=1a27b6fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a27b6fe",
  null
  
)

export default component.exports